import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';
import { PaginationInput } from '../store/types';

export type CreateExtractionRequestInput = {
  account_number: string;
  amount: number;
  beneficiary_id: string;
	description: string;
  /** Segundo factor: código OTP/TOTP o autorización biométrica ('bio:<nonce>'). */
  twoFactorCode?: string;
};

/**
 * Comisión de una solicitud de pago resuelta antes de crearla.
 *
 * Con `feeApplicationMode: 'ADDED'` la comisión se cobra POR ENCIMA del importe: de la
 * cuenta salen `reservedAmount` (importe + comisión) y el beneficiario cobra el importe
 * íntegro. Con `INCLUDED` no hay nada que mostrar: `reservedAmount` es el importe.
 */
export type ExtractionRequestFeePreview = {
  feeApplicationMode: 'INCLUDED' | 'ADDED';
  feePercent: number | null;
  feeAmount: number;
  reservedAmount: number;
  feeSource: 'customer' | 'core' | 'none';
};

export type GetExtractionRequestsDto = {
  search?: string;
  account_number?: string;
  status?: string;
  beneficiary_id?: string;
};

@Injectable({ providedIn: 'root' })
export class ExtractionRequestService extends ApiService {
  getExtractionRequests(pagination: PaginationInput, dto: GetExtractionRequestsDto) {
    return this.post(`${API.getExtractionRequests}`, { body: { pagination, dto } });
  }

  createExtractionRequest(extractionRequestData: CreateExtractionRequestInput, idempotencyKey?: string) {
    const options: any = { body: extractionRequestData };
    if (idempotencyKey) {
      options.headers = { 'idempotency-key': idempotencyKey };
    }
    return this.post<any>(`${API.createExtractionRequest}`, options);
  }

  /** Comisión y monto total a debitar de una solicitud, sin crearla. */
  previewFee(beneficiaryId: string, amount: number) {
    return this.post<ExtractionRequestFeePreview>(`${API.previewExtractionRequestFee}`, {
      body: { beneficiary_id: beneficiaryId, amount }
    });
  }

  updateExtractionRequest(
    extractionRequestId: string,
    data: Partial<CreateExtractionRequestInput>
  ) {
    return this.put<any>(`${API.updateExtractionRequest}/${extractionRequestId}`, { body: data });
  }

  deleteExtractionRequest(extractionRequestId: string) {
    return this.delete<any>(`${API.deleteExtractionRequest}/${extractionRequestId}`);
  }

  cancelExtractionRequest(extractionRequestId: string) {
    return this.post<any>(`${API.cancelExtractionRequest}/${extractionRequestId}/cancel`, {
      body: {}
    });
  }
}
